import React, { useState, useEffect } from "react";
import GuidedSessionCard from "./GuidedSessionCard";
import RightBar from "./RightBar";
import Sessions from "./Sessions";
import PlanCard from "./PlanCard";
import ReadMore from "./ReadMore";
import styles from "../../_css/Home.module.css";
import { useSelector, useDispatch } from "react-redux";
import { pageChange } from "../../_store/reducers/pageChangeReducer";
import { fetchCategories, fetchSessions } from "../../requests";
import { deleteAuthToken } from "../../utils/helper";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";

const CATEGORY_PAGE_SIZE = 10;

function Index() {
  const [remainingDays, setRemainingDays] = useState(0);
  
  // Sessions component state moved here to persist across navigation
  const [openSections, setOpenSections] = useState([]);
  const [sectionPage, setSectionPage] = useState(1);
  const [sections, setSections] = useState([]);
  const [sectionsData, setSectionsData] = useState({});
  const [fetchingSections, setFetchingSections] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryPagination, setCategoryPagination] = useState(null);

  const dispatch = useDispatch();
  const page = useSelector((state) => state.pageChange.page) || "home";
  const lang = useSelector((state) => state.language.lang);


  useEffect(() => {
    if (localStorage.getItem("page")) {
      dispatch(pageChange("readMore"));
    }
  }, []);

  useEffect(() => {
    getAllCategories(sectionPage);
  }, [sectionPage, lang]);

  useEffect(() => {
    if (selectedCategory?.id) {
      getAllSessions(selectedCategory.id);
    }
  }, [selectedCategory]);

  const getAllCategories = async (page = 1) => {
    dispatch(startLoader());
    try {
      const response = await fetchCategories({
        lang: lang,
        page,
        limit: CATEGORY_PAGE_SIZE,
        isPagination: true,
      });

      const categories = response.data.categoryResult || [];
      setSections(categories);
      setCategoryPagination(response.data.pagination || null);
      setOpenSections([]);

      if (categories.length > 0) {
        setSelectedCategory(categories[0]);
      } else {
        setSelectedCategory(null);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };

  const getAllSessions = async (categoryId) => {
    setFetchingSections(prev => ({ ...prev, [categoryId]: true }));
    try {
      const response = await fetchSessions({
        categoryId: categoryId,
      });

      const rows = response?.data?.sessions;
      

      setSectionsData(prev => ({
        ...prev,
        [categoryId]: rows
      }));
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    setFetchingSections(prev => ({ ...prev, [categoryId]: false }));
  };

  return (
    <>
      {page === "readMore" ? (
        <ReadMore />
      ) : (
        <div className={`d-flex gap-3 ${styles.homeContainer}`} >
          <div className={styles.homeContainerLeft}>
            <GuidedSessionCard />
            <Sessions 
              onReadMore={() => (localStorage.setItem("page", "readMore"), dispatch(pageChange("readMore")))} 
              onReadMoreWithStart={() => dispatch(pageChange("readMoreWithStart"))}
              // Pass state and handlers as props
              openSections={openSections}
              setOpenSections={setOpenSections}
              sectionPage={sectionPage}
              setSectionPage={setSectionPage}
              sections={sections}
              sectionsData={sectionsData}
              fetchingSections={fetchingSections}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              categoryPagination={categoryPagination}
            />
          </div>
          <div className={styles.rightBarContainer}>
            <RightBar setRemainingDays={setRemainingDays} />
            <PlanCard remainingDays={remainingDays} />
          </div>
        </div>
      )}
    </>
  );
}

export default Index;
